module.exports = __webpack_public_path__ + "static/media/0285_Small.f0cc3a12.jpg";